import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import Link from 'components/shared/link';

import MainContext from 'context/main';
import styles from './banner.module.scss';
import Shape1 from './svg/shape-1.inline.svg';
import Shape2 from './svg/shape-2.inline.svg';
import Icon from './svg/arrow.inline.svg';
import PhoneIcon from '../icons/Phone';

const cx = classNames.bind(styles);

const Banner = () => {
  const { sharedBlocks } = useContext(MainContext);

  const {
    banner: {
      acf: { title, label, buttonText, url, salePhoneNumber, techSupportPhoneNumber },
    },
  } = sharedBlocks || {};

  return (
    <div className={cx('wrapper')}>
      <div className={cx('container')}>
        <div className={cx('inner')}>
          {label && <span className={cx('label')}>{label}</span>}
          {!title && !url && <span />}
          {title && (
            <p className={cx('text')}>
              {title} <Icon className={cx('icon')} />
            </p>
          )}
          {url && buttonText && (
            <Link className={cx('left')} to={url}>
              <span className={cx('button', title ? 'withSeparator' : undefined)}>
                {buttonText}
                <Icon className={cx('icon')} />
              </span>
            </Link>
          )}
          {salePhoneNumber || techSupportPhoneNumber ? (
            <div className={cx('right')}>
              <div className={cx('contactInfo')}>
                {salePhoneNumber && (
                  <a href={`tel:${salePhoneNumber}`}>
                    <PhoneIcon />
                    Sales: {salePhoneNumber}
                  </a>
                )}
                {techSupportPhoneNumber && (
                  <a href={`tel:${techSupportPhoneNumber}`}>
                    <PhoneIcon />
                    Tech Support: {techSupportPhoneNumber}
                  </a>
                )}
              </div>
            </div>
          ) : null}
          {/* {logo && <img className={cx('logo')} src={logo.localFile.publicURL} alt={logo.altText} />} */}
        </div>

        <Shape1 className={cx('shape', 'shape-1')} />
        <Shape2 className={cx('shape', 'shape-2')} />
      </div>
    </div>
  );
};

export default Banner;
